import Icons from "assets/Icons";
import React from 'react';
import { Link } from 'react-router-dom';

import { Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

import { fetchGraphQL } from 'services/graphql/GraphQL';

import { AppConfig } from 'config/app';

class EventToolbar extends React.Component<{ [label: string]: any }, { [label: string]: any }> {

    constructor(props) {
        super(props);
        this.state = {
            scanner: false,
            promoter: false,
            isActive: false,
            display: false
        }
    }

    public componentDidMount() {
        if (this.props.eventId === undefined || this.props.eventId === null) {
            return;
        }
        fetchGraphQL(`
        query {
            event {
              get(eventId:"${this.props.eventId}") {
                  promoters
                  checkers
                  isActive
                  hosts
              }
            }
        }
        `).then(res => {
            if (res !== undefined) {
                if (res.event !== undefined && res.event !== null) {
                    if (res.event.get !== undefined && res.event.get !== null) {
                        if (res.event.get.promoters.includes(this.props.userId)) {
                            this.setState({ promoter: true });
                        }
                        if (res.event.get.checkers.includes(this.props.userId)) {
                            this.setState({ scanner: true })
                        }
                        // Extra check !!!
                        if (res.event.get.hosts.includes(this.props.userId)) {
                            this.setState({ scanner: false, promoter: false })
                        }
                        if (res.event.get.isActive) {
                            this.setState({ isActive: true })
                        }
                        this.setState({ display: true })
                    }
                }
            }
        })
    }
    public render() {

        let title = ''

        if (this.state.display !== true) {
            return null;
        }

        if (this.props.dashboard) {
            title = 'Dashboard'
        } else if (this.props.sell) {
            title = 'Sell Tickets'
        } else if (this.props.checkin) {
            title = 'Check-In'
        } else if (this.props.settings) {
            title = 'Settings'
        }

        return <div>
            {/* THIS IS FOR DESKTOP VERSIONS */}
            <div className="big-split-768" style={{ width: '100%', paddingBottom: '50px' }}>
                <div style={{ float: 'left', width: 'auto' }}>
                    <div className="p-r-20" style={{ float: 'left' }}>
                        <a href={AppConfig.hostUrl + "/manage/events"}>
                            <Button
                                className="new-button-white-icon"
                                role="button"
                                style={{
                                    border: 'none'
                                }}
                                id="back"
                            >
                                <img src={Icons.leftArrow} alt="Back" style={{ paddingTop: '6px' }} />
                            </Button>
                        </a>
                    </div>
                    {
                        this.state.scanner ? null :
                            <span>
                                {
                                    this.state.isActive ?
                                        <div className="p-r-20" style={{ float: 'left' }}>

                                            <Button
                                                className="new-button-white-icon"
                                                role="button"
                                                onClick={e => {
                                                    window.location.pathname = "/manage/activate/digital/" + this.props.eventId
                                                }}
                                                id="sell"
                                                // disabled={this.props.sell ? true : false}
                                                style={{
                                                    border: 'none',
                                                    // backgroundColor: this.props.sell ? '#f8f8f8' : '#ebecf1',
                                                    // boxShadow: this.props.sell ? '0 4px 2px -2px gray' : '0 2px 1px -1px gray'
                                                }}>
                                                <img src={Icons.sell} alt="Sell" />
                                            </Button>

                                        </div>
                                        : null
                                }
                                <div className="p-r-20" style={{ float: 'left' }}>

                                    <Button
                                        className="new-button-white-icon"
                                        role="button"
                                        // disabled={this.props.dashboard ? true : false}
                                        onClick={e => {
                                            window.location.pathname = '/manage/events/detail/' + this.props.eventId;
                                        }}
                                        style={{
                                            border: 'none',
                                            // backgroundColor: this.props.dashboard ? '#f8f8f8' : '#ebecf1',
                                            // boxShadow: this.props.dashboard ? '0 4px 2px -2px gray' : '0 2px 1px -1px gray'
                                        }}
                                        id="dashboard"
                                    >
                                        <img src={Icons.dashboard} alt="Dashboard" />
                                    </Button>

                                </div>
                            </span>
                    }
                    {
                        this.state.promoter || this.state.scanner ?
                            null :
                            <div style={{ float: 'left', width: 'auto', paddingTop: '0 auto' }}>
                                <div className="p-r-20" style={{ float: 'left' }}>

                                    <UncontrolledDropdown style={{ paddingTop: '0 auto' }}>
                                        <DropdownToggle className="new-button-white-icon"
                                            style={{
                                                border: 'none',
                                                // backgroundColor: this.props.settings ? '#f8f8f8' : '#ebecf1',
                                                // boxShadow: this.props.settings ? '0 4px 2px -2px gray' : '0 2px 1px -1px gray'
                                            }}
                                            id="settings"
                                            caret={true}
                                        >
                                            <img src={Icons.settings} alt="Settings" />
                                        </DropdownToggle>
                                        <DropdownMenu right={true} style={{ borderRadius: '30px' }}>
                                            <Link to={'/manage/events/edit/' + this.props.eventId + '?tab=details'} style={{ textDecoration: 'none' }}>
                                                <DropdownItem id="details">
                                                    SETTINGS
                                                </DropdownItem>
                                            </Link>
                                            <Link to={'/manage/events/edit/' + this.props.eventId + '?tab=publicTickets'} style={{ textDecoration: 'none' }}>
                                                <DropdownItem id="general">
                                                    INVENTORY
                                                </DropdownItem>
                                            </Link>
                                            <Link to={'/manage/events/edit/' + this.props.eventId + '?tab=team'} style={{ textDecoration: 'none' }}>
                                                <DropdownItem id="team">
                                                    TEAM
                                            </DropdownItem>
                                            </Link>
                                            <Link to={'/manage/events/edit/' + this.props.eventId + '?tab=referral-codes'} style={{ textDecoration: 'none' }}>
                                                <DropdownItem id="team">
                                                    REFERRAL LINKS
                                            </DropdownItem>
                                            </Link>
                                            {/* <Link to={'/manage/events/edit/' + this.props.eventId + '?tab=privateTickets'} style={{ textDecoration: 'none' }}>
                                                <DropdownItem id="promoter">
                                                    PROMOTER TICKET INVENTORY
                                                </DropdownItem>
                                            </Link>
                                            <Link to={'/manage/events/edit/' + this.props.eventId + '?tab=referrals'} style={{ textDecoration: 'none' }}>
                                                <DropdownItem id="referral">
                                                    REFERRAL LINKS
                                                </DropdownItem>
                                            </Link> */}
                                            <Link to={'/manage/events/edit/' + this.props.eventId + '?tab=announcements'} style={{ textDecoration: 'none' }}>
                                                <DropdownItem id="announcements">
                                                    ANNOUNCEMENTS
                                                </DropdownItem>
                                            </Link>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>

                                </div>
                            </div>
                    }
                    {
                        this.state.promoter ?
                            null :
                            this.state.isActive ?
                                <div className="p-r-20" style={{ float: 'left' }}>

                                    <Button
                                        className="new-button-white-icon"
                                        role="button"
                                        onClick={e => {
                                            window.location.pathname = '/manage/events/checkin/' + this.props.eventId
                                        }}
                                        id="checkin"
                                        // disabled={this.props.checkin ? true : false}
                                        style={{
                                            border: 'none',
                                            // backgroundColor: this.props.checkin ? '#f8f8f8' : '#ebecf1',
                                            // boxShadow: this.props.checkin ? '0 4px 2px -2px gray' : '0 2px 1px -1px gray'
                                        }}>
                                        <img src={Icons.checkin} alt="Checkin" />
                                    </Button>

                                </div>
                                : null
                    }
                </div>
                <span style={{ float: 'right', lineHeight: '40px' }}>
                    {this.props.eventName} <span className="sexyBlack" style={{ paddingLeft: '5px', fontSize: '25px', fontFamily: 'Poppins' }}><b>{title}</b></span>
                </span>
            </div>
            {/* THIS IS FOR MOBILE */}
            <div className="small-split-768" style={{ width: '100%' }}>
                <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                    <div className="p-r-20" style={{ float: 'left' }}>
                        <a href={AppConfig.hostUrl + "/manage/events"}>
                            <Button
                                className="new-button-white-icon"
                                role="button"
                                style={{
                                    border: 'none'
                                }}>
                                <img src={Icons.leftArrow} alt="Back" style={{ paddingTop: '6px' }} />
                            </Button>
                        </a>
                    </div>
                    {
                        this.state.scanner ? null :
                            <span>
                                {
                                    this.state.isActive ?
                                        <div className="p-r-20" style={{ float: 'left' }}>

                                            <Button
                                                className="new-button-white-icon"
                                                role="button"
                                                onClick={e => {
                                                    window.location.pathname = "/manage/activate/digital/" + this.props.eventId
                                                }}
                                                // disabled={this.props.sell ? true : false}
                                                style={{
                                                    border: 'none',
                                                    // backgroundColor: this.props.sell ? '#f8f8f8' : '#ebecf1',
                                                    // boxShadow: this.props.sell ? '0 4px 2px -2px gray' : '0 2px 1px -1px gray'
                                                }}>
                                                <img src={Icons.sell} alt="Sell" />
                                            </Button>

                                        </div>
                                        : null
                                }
                                <div className="p-r-20" style={{ float: 'left' }}>

                                    <Button
                                        className="new-button-white-icon"
                                        role="button"
                                        // disabled={this.props.dashboard ? true : false}
                                        onClick={e => {
                                            window.location.pathname = '/manage/events/detail/' + this.props.eventId;
                                        }}
                                        style={{
                                            border: 'none',
                                            // backgroundColor: this.props.dashboard ? '#f8f8f8' : '#ebecf1',
                                            // boxShadow: this.props.dashboard ? '0 4px 2px -2px gray' : '0 2px 1px -1px gray'
                                        }}>
                                        <img src={Icons.dashboard} alt="Dashboard" />
                                    </Button>
                                </div>
                            </span>
                    }
                    {
                        this.state.promoter || this.state.scanner ?
                            null :
                            <div style={{ float: 'left', width: 'auto', paddingTop: '0 auto' }}>
                                <div className="p-r-20" style={{ float: 'left' }}>
                                    <UncontrolledDropdown style={{ paddingTop: '0 auto' }}>
                                        <DropdownToggle className="new-button-white-icon"
                                            style={{
                                                border: 'none',
                                            }}
                                            caret={true}
                                        >
                                            <img src={Icons.settings} alt="Settings" />
                                        </DropdownToggle>
                                        <DropdownMenu right={true} style={{ borderRadius: '30px' }}>
                                            <Link to={'/manage/events/edit/' + this.props.eventId + '?tab=details'} style={{ textDecoration: 'none' }}>
                                                <DropdownItem id="details">
                                                    SETTINGS
                                                </DropdownItem>
                                            </Link>
                                            <Link to={'/manage/events/edit/' + this.props.eventId + '?tab=publicTickets'} style={{ textDecoration: 'none' }}>
                                                <DropdownItem id="general">
                                                    INVENTORY
                                                </DropdownItem>
                                            </Link>
                                            <Link to={'/manage/events/edit/' + this.props.eventId + '?tab=team'} style={{ textDecoration: 'none' }}>
                                                <DropdownItem id="team">
                                                    TEAM
                                            </DropdownItem>
                                            </Link>
                                            <Link to={'/manage/events/edit/' + this.props.eventId + '?tab=referral-codes'} style={{ textDecoration: 'none' }}>
                                                <DropdownItem id="team">
                                                    REFERRAL LINKS
                                            </DropdownItem>
                                            </Link>
                                            <Link to={'/manage/events/edit/' + this.props.eventId + '?tab=announcements'} style={{ textDecoration: 'none' }}>
                                                <DropdownItem id="announcements">
                                                    ANNOUNCEMENTS
                                                </DropdownItem>
                                            </Link>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                    }
                    {
                        this.state.promoter ?
                            null :
                            this.state.isActive ?
                                <div className="p-r-20" style={{ float: 'left' }}>

                                    <Button
                                        className="new-button-white-icon"
                                        role="button"
                                        onClick={e => {
                                            window.location.pathname = '/manage/events/checkin/' + this.props.eventId
                                        }}
                                        // disabled={this.props.checkin ? true : false}
                                        style={{
                                            border: 'none',
                                            // backgroundColor: this.props.checkin ? '#f8f8f8' : '#ebecf1',
                                            // boxShadow: this.props.checkin ? '0 4px 2px -2px gray' : '0 2px 1px -1px gray'
                                        }}>
                                        <img src={Icons.checkin} alt="Checkin" />
                                    </Button>

                                </div>
                                : null
                    }
                </div>
                <div style={{ textAlign: 'center', width: '100%', }}>
                    <br />{this.props.eventName} <br /><span className="sexyBlack" style={{ paddingLeft: '5px', fontSize: '25px', fontFamily: 'Poppins' }}><b>{title}</b></span>
                </div>
            </div>
            <p />
        </div>
    }

}


export default EventToolbar;


// WEBPACK FOOTER //
// ./src/pages/manage/events/detail/EventToolbar.tsx